import { Skeleton } from "@/components/ui/skeleton";
import {
  getRosterBodyFirstColPx,
  ROSTER_DAY_CELL_PX,
  ROSTER_GRID_GAP_PX,
  type RosterTableLayoutConfig,
} from "@/components/nurse/rosterColumnHoverLayout";

export function IssuedRosterTeamSkeleton({ daysInMonth, nurseCount, layoutConfig }: {
  daysInMonth: number;
  nurseCount: number;
  layoutConfig?: RosterTableLayoutConfig;
}) {
  const rowCount = Math.min(nurseCount, 12);
  const groups = Array.from({ length: Math.ceil(rowCount / 4) }, (_, index) =>
    Math.min(4, rowCount - index * 4)
  );
  return (
    <div role="status" aria-label="팀별 근무표를 불러오는 중입니다">
      <span className="sr-only">팀별 근무표를 불러오는 중입니다.</span>
      <div aria-hidden="true" className="flex flex-col gap-6 motion-safe:animate-pulse">
        {groups.map((rows, groupIndex) => (
          <div key={groupIndex}>
            <div className="mb-2 grid grid-cols-[48px_auto] items-center gap-6 rounded-lg bg-[#F0F0F2] px-4 py-3">
              <Skeleton className="ml-auto h-3 w-7 animate-none bg-zinc-200" />
              <Skeleton className="mx-auto h-3 w-20 animate-none bg-zinc-200" />
            </div>
            {Array.from({ length: rows }, (_, rowIndex) => (
              <div key={rowIndex} className="flex items-center py-2" style={{ gap: ROSTER_GRID_GAP_PX }}>
                <div className="flex shrink-0 items-center gap-4 px-3" style={{ width: getRosterBodyFirstColPx("create", layoutConfig) }}>
                  <Skeleton className="h-3 w-4 shrink-0 animate-none bg-zinc-200" />
                  <Skeleton className="h-3 w-16 animate-none bg-zinc-200" />
                </div>
                <div className="flex">
                  {Array.from({ length: daysInMonth }, (_, day) => (
                    <div key={day} className="flex shrink-0 justify-center" style={{ width: ROSTER_DAY_CELL_PX }}>
                      <Skeleton className="size-6 animate-none rounded-sm bg-zinc-100" />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
